import * as autosubmit from "./autosubmit";
import * as current from "./current";
import * as embed from "./embed";
import * as enabled from "./enabled";
import * as hotkeys from "./hotkeys";
import * as inline from "./inline";
import * as remove from "./remove";
import * as replace from "./replace";
import * as toggle from "./toggle";
export default {
  autosubmit,
  current,
  embed,
  enabled,
  hotkeys,
  inline,
  remove,
  replace,
  toggle
};